export default __webpack_public_path__ + "140f3c96.svg";